import { useMatomo } from "@jonkoops/matomo-tracker-react";
import { useState } from "react";

function FAQ() {
    const { trackEvent } = useMatomo(); 

    const [selectedIndex, setSelectedIndex] = useState(-1);

    const onQuestionClick = (i: number) => { 
        if(selectedIndex === i) {
            setSelectedIndex(-1);
        } else {
            setSelectedIndex(i);
        }
      }      

    const questions = [
        {
            question: "How do you ensure security & privacy?",
            answer: "Data protection and data security are core requirements for our software solution. We are currently in ISO 27001 certification and undergo regular audits. We support regulation and contribute to it."
        },
        {
            question: "Do you support customized Fund Models?",
            answer: "Our clients have the possibility to implement individual management & performance fee calculation models or to use our configurable standard models."
        },
        {
            question: "Which Protocols / Blockchains do you support?",
            answer: "We are continuously working on the expansion of our integration list. Besides classic projects like Bitcoin, Ethereum and ERC20 Token, we already support some newer eco-systems like Cosmos Hub. Feel free to contact us and we will send you an up-to-date overview."
        },
        {
            question: "Do you support Staking and Liquidity Mining?",
            answer: "Currently, we already support the automated capture of staking and liquidity mining assets for selected projects and eco-systems. A gradual expansion is progress."
        },
        {
            question: "Is there any documentation of the product?",
            answer: "For selected processes and calculations, like the Net Asset value calculation we provide process description confidentially for documentation purposes. For more information, please contact our sales team."
        },
        {
            question: "What is the pricing model?",
            answer: "We offer a basic subscription with a flexible premium on the net asset value of your fund, which is capped above a certain level. Our sales team will be glad to provide you with detailed information."
        },
        {
            question: "Is there a data export function?",
            answer: "We offer standardized PDF reports and the possibility to export selected data like fee statements, transaction lists, etc. as Excel Files."
        }
    ];

    const trackQuestionClick = (question: string, id: number) => {
        trackEvent({ category: 'FAQ', action: `question #${id} clicked: ${question}` });
    }

    return (
        <div className="max-lg:p-5">
            <div className="bg-slate-100 w-full max-w-screen-md h-fit box mx-auto rounded-3xl p-10" id="faq">
                <h1 className="text-4xl font-bold text-slate-800 mb-3 max-md:text-3xl">
                    Frequently asked<br/>questions
                </h1>
                <p className="font-medium text-slate-400 mb-10">
                    <span>
                        Do you have more questions? <br/> Write us at 
                    </span>
                    <a href="mailto:contact@3folio.finance" className="text-slate-600">
                        {" "} contact@3folio.finance
                    </a>
                </p>
                { questions.map((question, i) => (
                    <div className="relative" key={"question-" + i}>
                        <div className="cursor-pointer" onClick={() => {onQuestionClick(i); trackQuestionClick(question.question, i+1);} }>
                            <h2 className="text-xl font-semibold text-left text-slate-800 mb-3 w-10/12">
                                {question.question}
                            </h2>
                            <i className={(selectedIndex === i ? "iconoir-nav-arrow-up" : "iconoir-nav-arrow-down") + " text-3xl font-semibold text-left absolute right-0 top-0" }></i> 
                        </div>
                        {
                            selectedIndex === i && (
                                <p className="font-medium text-slate-400 text-left">
                                    {question.answer}
                                </p>
                            )
                        }
                        {
                            i !== questions.length - 1 && <hr className="my-7"/>
                        }
                    </div>
                ))}
            </div>
        </div>
    )
}

export default FAQ;